// extracted by mini-css-extract-plugin
export default {"root":"DemographicWidgetContainer_root__qVKz6"};